import cssVarsPonyfill from 'css-vars-ponyfill';
import massageDataUtil from './utils/massageDataUtil';
import globalThemeUtil from './utils/globalThemeUtil';
import buttonThemeUtil from './utils/buttonThemeUtil';
import mastheadThemeUtil from './utils/mastheadThemeUtil';
import widgetThemeUtil from './utils/widgetThemeUtil';
import bodyThemeUtil from './utils/bodyThemeUtil';
import mobileThemeUtil from './utils/mobileThemeUtil';
import applyCustomCSS from './utils/applyCustomCSS';
// import mockBranding from './__mocks__/branding.json';

// Styles
import './styles/branding.scss';

const getThemeVariables = (config /* = mockBranding */) => {
    const { attributes } = config || {};
    let variables = {};

    // TODO: remove logs after QA debug
    console.log('applyBrandingConfig.getThemeVariables() config: ', config);

    if (attributes && attributes.length > 0) {
        const massagedData = massageDataUtil(attributes);

        variables = {
            ...variables,
            ...globalThemeUtil(massagedData),
            ...bodyThemeUtil(massagedData),
            ...mastheadThemeUtil(massagedData),
            ...widgetThemeUtil(massagedData),
            ...buttonThemeUtil(massagedData),
            ...mobileThemeUtil(massagedData),
        };
    }

    return variables;
};

const isNativePolyfillSupport =
    typeof window !== 'undefined' &&
    window.CSS &&
    window.CSS.supports &&
    window.CSS.supports('(--a: 0)');
const applyBrandingConfig = (
    config,
    themeId,
    rootElement,
    cssSelector,
) => /* = mockBranding */ {
    const { attributes } = config || {};
    let variables = {};

    if (attributes && attributes.length > 0) {
        const element = rootElement ?? document.documentElement;
        variables = getThemeVariables(config);

        if (isNativePolyfillSupport) {
            Object.getOwnPropertyNames(variables).forEach((varName) => {
                element.style.setProperty(varName, variables[varName]);
            });
        } else {
            // Reference https://jhildenbiddle.github.io/css-vars-ponyfill/#/?id=usage
            // for ponyfill in IE11, it seeems to fail without this
            if (window.console && !window.console.error) {
                window.console.error = () => {};
            }

            if (window.console && !window.console.warn) {
                window.console.warn = () => {};
            }
            cssVarsPonyfill({
                updateDOM: true,
                include: cssSelector || '#experience-branding-css',
                variables,
            });
        }

        applyCustomCSS(attributes);
    }
};

const applyTheme = (theme, element, customCSSVars) => {
    const setCSSProperties = (cssVars) => {
        Object.getOwnPropertyNames(cssVars).forEach((varName) => {
            element.style.setProperty(varName, cssVars[varName]);
        });
    };

    if (element && theme) {
        const { attributes = [] } = theme;
        (attributes ?? []).forEach((attrParam) => {
            const attr = attrParam;

            if (attr.value && typeof attr.value !== 'string') {
                attr.value = attr.value.toString();
            }
        });

        const themeCssVars = getThemeVariables(theme);
        setCSSProperties(themeCssVars);

        if (customCSSVars) {
            setCSSProperties(customCSSVars);
        }
    }
};

export { getThemeVariables, applyTheme };

export default applyBrandingConfig;
